import {combineReducers} from 'redux';
import CreateTestReducer from './create_teset_reducer/CreateTestReducer';
import EditTestReducer from './edit_test_reducer/EditTestReducer';

export default combineReducers({
  createTest: CreateTestReducer,
  editTest: EditTestReducer,
});
